import { observer } from 'mobx-react';
import Box from '@mui/material/Box';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
import { useEffect, useRef, useState } from 'react';
import { Button, Card, CardContent, Drawer, Grid, Paper, Stack, Typography } from '@mui/material';
import { AppNavbar } from '../../components/AppNavbar';
import { UsersList } from '../../components/UsersList';
import { NewUserDialog } from '../../components/NewUserDialog';
import { PipelinesMenu } from '../../components/PipelinesMenu';
import LeadStore from '../../store/LeadStore';
import LoadingProgressStore from '../../store/LoadingProgressStore';

const defaultTheme = createTheme({
  typography: {
    button: {
      textTransform: 'none',
    },
  },
});

const CustomButton = styled(Button)({
  backgroundColor: '#F07B0E',
  color: '#fff',
  '&:hover': {
    backgroundColor: '#d67e2d',
  },
  width: 'fit-content',
  height: '34px',
});

const SubNavBarCard = styled(Card)({
  top: '49px',
  position: 'fixed',
  width: '-webkit-fill-available',
  zIndex: '10',
  height: '45px',
  minHeight: '45px',
});

export const WorkflowStages = observer(({}) => {
  const [selectedPipeline, setSelectedPipeline] = useState(null);

  const handleSelectedPipelineChanged = (pipeline) => {
    setSelectedPipeline(pipeline);
  };

  useEffect(() => {
    LoadingProgressStore.toggleIsLoading(true);
    selectedPipeline && LeadStore.getWorkflowStatusByPipeLineId(selectedPipeline.id);
  }, [selectedPipeline]);

  useEffect(() => {
    LoadingProgressStore.toggleIsLoading(false);
  }, [LeadStore.workflowStatusByPipeLine]);

  return (
    // <ThemeProvider theme={defaultTheme}>
    <Card>
      <AppNavbar></AppNavbar>
      <Box sx={{ boxShadow: 'unset', overflow: 'auto' }}>
        <Stack direction="column">
          <SubNavBarCard>
            <CardContent sx={{ pt: '6px !important', pb: '6px !important' }}>
              <Stack justifyContent="space-between" direction="row" spacing={2}>
                <Stack>
                  <PipelinesMenu handleSelectedPipelineChanged={handleSelectedPipelineChanged}></PipelinesMenu>
                </Stack>
              </Stack>
            </CardContent>
          </SubNavBarCard>
          <Box
            flexGrow={1}
            sx={{
              top: '95px',
              position: 'absolute',
              width: '-webkit-fill-available',
              p: '25px',
              boxShadow: 'unset',
              backgroundColor: '#D7E3EF',
            }}
          >
            <Grid container gap={2} p={'10px'} justifyContent={'space-evenly'}>
              {LeadStore.workflowStatusByPipeLine?.map((item, index) => {
                return (
                  <Grid item key={index} xs={12} sm={6} md={4} lg={3}>
                    <Paper width={'100%'} height={'100%'}>
                      <Stack
                        direction={'row'}
                        sx={{
                          borderBottom: '1px solid #c7c7c782',
                          backgroundColor: '#c7c7c782',
                          px: '20px',
                          py: '10px',
                        }}
                      >
                        <Typography sx={{ fontWeight: '600', alignSelf: 'start' }} component="p">
                          {item.name}
                        </Typography>
                      </Stack>
                      <Stack direction={'row'} sx={{ p: '20px' }} spacing={2} alignItems={'center'}>
                        <Typography
                          sx={{
                            fontWeight: '500',
                            alignSelf: 'start',
                            color: '#626A72',
                          }}
                          component="p"
                        >
                          {item.description ?? 'No additional info available'}
                        </Typography>
                      </Stack>
                    </Paper>
                  </Grid>
                );
              })}
              {(!LeadStore.workflowStatusByPipeLine || !LeadStore.workflowStatusByPipeLine.length) && (
                <Paper>
                  <Stack
                    direction={'row'}
                    sx={{
                      borderBottom: '1px solid #c7c7c782',
                      borderRadius: '6px',
                      backgroundColor: '#fff',
                      px: '20px',
                      py: '10px',
                    }}
                  >
                    <Typography sx={{ fontWeight: '600' }} component="p">
                      No workflow status available for this pipeline
                    </Typography>
                  </Stack>
                </Paper>
              )}
            </Grid>
          </Box>
        </Stack>
      </Box>
    </Card>
    // </ThemeProvider>
  );
});
